// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Components
import LanguageItem from "./components/LanguageItem";
import SelectedLanguage from "./components/SelectedLanguage";
// i18n
import i18n from "../../../../config/translation/i18n";

class LanguageSelector extends Component {
  constructor(props) {
    super(props);
    /**
     * Set the English as a fallback language in case everything else fail
     * the english that is set here, is the one that is on the json files
     * so we always get the fallback translation
     */
    this.state = {
      language: props.locales[0].locale,
      localeName: props.locales[0].localeName,
      menuOpen: false
    };
  }

  componentDidMount() {
    const defaultLanguage = this.props.locales.find((lng) => lng.isDefault);

    if (defaultLanguage) {
      this.setState({
        language: defaultLanguage.locale,
        localeName: defaultLanguage.localeName
      });
      i18n.changeLanguage(defaultLanguage.locale);
    } else if (this.props.language !== this.state.language) {
      const isLanguageInLocales = this.props.locales.find(
        ({ locale }) => locale === this.props.language
      );

      if (isLanguageInLocales) {
        this.setState({
          language: this.props.language,
          localeName: isLanguageInLocales.localeName
        });
      }
    }
  }

  getLocaleNameFromLocales = (language) => {
    const { locales } = this.props;

    return locales.find(({ locale }) => locale === language).localeName;
  };

  selectLanguage = (language) => () => {
    this.setState({
      language,
      localeName: this.getLocaleNameFromLocales(language),
      menuOpen: false
    });

    i18n.changeLanguage(language);
  };

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen
    }));
  };

  hideMenu = () => {
    this.setState({
      menuOpen: false
    });
  };

  render() {
    const { locales } = this.props;
    const { language, localeName, menuOpen } = this.state;

    return (
      <ul
        onBlur={this.hideMenu}
        onFocus={this.hideMenu}
        tabIndex="0"
        className="header-dropdown-list ng-cloak"
      >
        <li className="dropdown">
          <SelectedLanguage iconClass="fa fa-globe" onClick={this.toggleMenu} text={localeName} />
          <ul
            className="dropdown-menu pull-right"
            style={{
              display: menuOpen ? "block" : "none"
            }}
          >
            {locales.map(({ locale, localeName }, index) => (
              <LanguageItem
                active={locale === language}
                key={index}
                onClick={this.selectLanguage(locale)}
                text={localeName}
              />
            ))}
          </ul>
        </li>
      </ul>
    );
  }
}

const mapStateToProps = (state) => ({
  locales: state.localization.locales
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageSelector);
